// Pure helpers over the Post-Acquisitions Channel/RequestType/Stage taxonomy.
// The taxonomy is served by the backend via /api/appSetting (see
// AppSettingController.GetAppSettings on the server, mirrored to
// PostAcquisitionRequestTypeLookup). Callers pass the entries array in.

export const getChannels = entries =>
  [...new Set(entries.map(e => e.channel))];

export const getRequestTypesForChannel = (entries, channel) =>
  entries.filter(e => e.channel === channel).map(e => e.requestType);

export const getStage = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.stage ?? null;

export const getRequiredProformaInputs = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.requiredProformaInputs ?? null;

// How requiredProformaInputs is interpreted: 'All' (every listed input required) or
// 'Any' (at least one of the listed inputs required). Defaults to 'All'. An empty/null
// requiredProformaInputs list means "at least one of any input" regardless of mode.
export const RequiredInputMatchMode = { ALL: 'All', ANY: 'Any' };

export const getRequiredInputMode = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.requiredInputMode ?? RequiredInputMatchMode.ALL;

// Returns true if saving an underwrite for this pair requires the Underwrite Manager
// role. False for unknown pairs.
export const getRequiresUnderwriteManager = (entries, channel, requestType) =>
  entries.find(e => e.channel === channel && e.requestType === requestType)?.requiresUnderwriteManager ?? false;

// Returns true if the channel is the Acquisitions channel — the one channel with special-cased
// behavior throughout Post-Acq (address-only import rows, no underwrite submission step, etc).
// Channel-level: true if any entry for the channel is flagged isAcquisitions.
export const isAcquisitionsChannel = (entries, channel) =>
  (entries ?? []).some(e => e.channel === channel && e.isAcquisitions);
